import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { Compute } from 'cerebral'
import MenuItem from './menuItem'
import isAdmin from 'utils/isAdmin'
import styles from './styles'
import { css } from 'aphrodite'
import { t } from '@billes/translator-client'

const computedNode = Compute(state`node.contextMenu.path`, (path, get) => {
  if (!path) return null
  return get(state`${path}`)
})

export default connect(
  {
    group: state`app.user.group`,
    contextMenu: state`node.contextMenu`,
    hideTreeContextMenu: signal`node.hideTreeContextMenu`,
    node: computedNode,
    showNodePanel: signal`node.showNodePanel`,
    path: state`node.contextMenu.path`,
    prepareRemoveNode: signal`node.prepareRemoveNode`,
    isMenuOpen: state`node.tree.open`,
    isMenuHover: state`node.tree.hover`
  },
  class ContextMenu extends Component {
    onBlur(e) {
      const { hideTreeContextMenu } = this.props
      hideTreeContextMenu()
    }

    renderItems() {
      const {
        node,
        showNodePanel,
        path,
        prepareRemoveNode,
        group,
        isMenuOpen,
        isMenuHover
      } = this.props

      if (!isAdmin(group) || (!isMenuOpen && !isMenuHover)) {
        return
      }
      if (!node) {
        return (
          <MenuItem
            label={t('bms.node.createRootNode')}
            onSelect={e => {
              showNodePanel({ path: null, edit: false })
            }}
          />
        )
      }
      const nodeItems = [
        {
          label: t('bms.node.edit', { name: node.name }),
          onSelect: e => {
            showNodePanel({ path, edit: true })
          }
        },
        {
          label: t('bms.node.remove', { name: node.name }),
          onSelect: () => {
            prepareRemoveNode({ path })
          }
        }
      ]

      nodeItems.unshift({
        label: t('bms.node.createUnderNode', { name: node.name }),
        onSelect: e => {
          showNodePanel({ path, edit: false })
        }
      })

      return nodeItems.map((item, index) => {
        return (
          <MenuItem key={index} label={item.label} onSelect={item.onSelect} />
        )
      })
    }

    render() {
      const { contextMenu: { isVisible, position } } = this.props
      if (!isVisible) return null
      return (
        <div
          ref={ref => ref && ref.focus()}
          className={css(styles.container)}
          tabIndex={0}
          style={{ left: position.x, top: position.y }}
          onBlur={e => this.onBlur(e)}>
          <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
            {this.renderItems()}
          </ul>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Menu/ContextMenu/contextMenu.js